<section class="elegibilidade" aria-labelledby="opcoes-renda-titulo" data-testid="beneficios-opcoes-renda">
  <header class="elegibilidade__topo">
    <span class="elegibilidade__icone" aria-hidden="true">
      <vivest-icon name="dollar-sign" source="feather"></vivest-icon>
    </span>
    <div class="elegibilidade__titulo-grupo">
      <h2 id="opcoes-renda-titulo" class="elegibilidade__titulo">Opções de Renda</h2>
      <p class="elegibilidade__descricao">Configure as opções de renda e o valor mínimo do plano. Valem para todos os benefícios.</p>
    </div>
  </header>

  @if (carregou()) {
    <div class="elegibilidade__blocos">
      <section class="elegibilidade-parametros" aria-labelledby="opcoes-renda-parametros-titulo">
        <div class="elegibilidade-parametros__cabecalho">
          <h3 id="opcoes-renda-parametros-titulo" class="elegibilidade__subtitulo">
            Parâmetros de Renda{{ nomePlano() ? ': ' : '' }}
            @if (nomePlano()) {
              <span class="elegibilidade-parametros__beneficio" data-testid="opcoes-renda-plano">{{ nomePlano() }}</span>
            }
          </h3>
        </div>

        <form
          class="elegibilidade-regras"
          novalidate
          [formGroup]="form"
          (submit)="$event.preventDefault(); salvar()"
          data-testid="opcoes-renda-form"
        >
          <fieldset
            class="elegibilidade-bloco"
            aria-labelledby="opcoes-renda-bloco-opcoes"
            formGroupName="opcoes"
            data-testid="opcoes-renda-bloco-opcoes"
          >
            <div class="elegibilidade-bloco__cabecalho">
              <h4 id="opcoes-renda-bloco-opcoes" class="elegibilidade-bloco__titulo">
                Opções de renda<span class="campanha-form-required" aria-hidden="true">*</span>
              </h4>
              <p class="elegibilidade-bloco__regra">Marque as formas de renda que o participante poderá escolher.</p>
            </div>
            <div class="elegibilidade-bloco__conteudo">
              <ul class="opcoes-renda-lista">
                @for (opcao of opcoesRenda; track opcao.value) {
                  <li
                    class="opcoes-renda-opcao"
                    [class.opcoes-renda-opcao--marcada]="marcada(opcao.value)"
                    [class.opcoes-renda-opcao--erro]="!!erroDaOpcao(opcao.value)"
                  >
                    <div class="opcoes-renda-opcao__linha">
                      <vivest-checkbox
                        class="opcoes-renda-opcao__nome"
                        label-variant="multi-line"
                        name="opcoes-renda"
                        [value]="opcao.value"
                        [formControlName]="opcao.value"
                        [attr.data-testid]="'opcoes-renda-opcao-' + opcao.value"
                      >
                        {{ opcao.label }}
                      </vivest-checkbox>

                      <!-- Marcada, a opção mostra os valores dela como frase (desmarcada, eles ficam guardados). -->
                      @if (marcada(opcao.value)) {
                        @switch (opcao.value) {
                          @case (opcaoRenda.PercentualSaldo) {
                            <p class="elegibilidade-frase" [attr.data-testid]="'opcoes-renda-parametros-' + opcao.value">
                              <span>De</span>
                              <input
                                type="number"
                                inputmode="decimal"
                                min="0"
                                max="100"
                                step="0.01"
                                placeholder="0"
                                aria-label="Percentual mínimo do saldo"
                                class="form-control campanha-form-control elegibilidade-frase__numero"
                                [formControl]="form.controls.parametros.controls.percentualSaldo.controls.minimo"
                                [class.is-invalid]="!!erroDaOpcao(opcao.value)"
                                data-testid="opcoes-renda-percentual-minimo"
                              />
                              <span>% a</span>
                              <input
                                type="number"
                                inputmode="decimal"
                                min="0"
                                max="100"
                                step="0.01"
                                placeholder="0"
                                aria-label="Percentual máximo do saldo"
                                class="form-control campanha-form-control elegibilidade-frase__numero"
                                [formControl]="form.controls.parametros.controls.percentualSaldo.controls.maximo"
                                [class.is-invalid]="!!erroDaOpcao(opcao.value)"
                                data-testid="opcoes-renda-percentual-maximo"
                              />
                              <span>% do saldo</span>
                            </p>
                          }
                          @case (opcaoRenda.PrazoCerto) {
                            <p class="elegibilidade-frase" [attr.data-testid]="'opcoes-renda-parametros-' + opcao.value">
                              <span>De</span>
                              <input
                                type="number"
                                inputmode="numeric"
                                min="1"
                                [max]="prazoMaximo[form.controls.parametros.controls.prazoCerto.controls.unidade.value]"
                                step="1"
                                placeholder="0"
                                aria-label="Prazo mínimo"
                                class="form-control campanha-form-control elegibilidade-frase__numero"
                                [formControl]="form.controls.parametros.controls.prazoCerto.controls.minimo"
                                [class.is-invalid]="!!erroDaOpcao(opcao.value)"
                                data-testid="opcoes-renda-prazo-minimo"
                              />
                              <span>a</span>
                              <input
                                type="number"
                                inputmode="numeric"
                                min="1"
                                [max]="prazoMaximo[form.controls.parametros.controls.prazoCerto.controls.unidade.value]"
                                step="1"
                                placeholder="0"
                                aria-label="Prazo máximo"
                                class="form-control campanha-form-control elegibilidade-frase__numero"
                                [formControl]="form.controls.parametros.controls.prazoCerto.controls.maximo"
                                [class.is-invalid]="!!erroDaOpcao(opcao.value)"
                                data-testid="opcoes-renda-prazo-maximo"
                              />
                              <span
                                class="elegibilidade-prazo__unidades"
                                role="radiogroup"
                                aria-label="Unidade do prazo"
                                data-testid="opcoes-renda-prazo-unidade"
                              >
                                @for (unidade of unidadesTempo; track unidade.value) {
                                  <label
                                    class="elegibilidade-prazo__unidade"
                                    [class.elegibilidade-prazo__unidade--ativa]="form.controls.parametros.controls.prazoCerto.controls.unidade.value === unidade.value"
                                  >
                                    <input
                                      type="radio"
                                      class="elegibilidade-prazo__radio"
                                      name="unidade-prazo-certo"
                                      [value]="unidade.value"
                                      [formControl]="form.controls.parametros.controls.prazoCerto.controls.unidade"
                                      [attr.data-testid]="'opcoes-renda-prazo-unidade-' + unidade.value"
                                    />
                                    {{ unidade.label }}
                                  </label>
                                }
                              </span>
                            </p>
                          }
                        }
                      }
                    </div>
                    @if (erroDaOpcao(opcao.value); as mensagem) {
                      <p class="elegibilidade__erro" role="alert" [attr.data-testid]="'opcoes-renda-erro-' + opcao.value">{{ mensagem }}</p>
                    }
                  </li>
                }
              </ul>
              @if (erroOpcoes(); as mensagem) {
                <p class="elegibilidade__erro" role="alert" data-testid="opcoes-renda-erro-opcoes">{{ mensagem }}</p>
              }
            </div>
          </fieldset>

          <fieldset
            class="elegibilidade-bloco"
            aria-labelledby="opcoes-renda-bloco-minimo"
            formGroupName="valorMinimo"
            data-testid="opcoes-renda-bloco-minimo"
          >
            <div class="elegibilidade-bloco__cabecalho">
              <h4 id="opcoes-renda-bloco-minimo" class="elegibilidade-bloco__titulo">Valor mínimo de renda</h4>
              <p class="elegibilidade-bloco__regra">
                O participante só poderá prosseguir se o valor da renda for igual ou maior que este valor.
              </p>
            </div>
            <div class="elegibilidade-bloco__conteudo">
              <div class="elegibilidade-campo">
                <span id="opcoes-renda-validar-rotulo" class="campanha-form-label">Validar valor mínimo de renda</span>
                <span class="elegibilidade-sim-nao">
                  <vivest-switch
                    formControlName="validar"
                    aria-labelledby="opcoes-renda-validar-rotulo"
                    data-testid="opcoes-renda-validar"
                  ></vivest-switch>
                  {{ form.controls.valorMinimo.controls.validar.value ? 'Sim' : 'Não' }}
                </span>
              </div>

              <!-- Com a validação desligada, os valores ficam guardados e voltam ao religar. -->
              @if (form.controls.valorMinimo.controls.validar.value) {
                <div class="elegibilidade-campo" role="radiogroup" aria-labelledby="opcoes-renda-tipo-rotulo">
                  <span id="opcoes-renda-tipo-rotulo" class="campanha-form-label">Definir o mínimo por</span>
                  <div class="opcoes-renda-tipos">
                    @for (tipo of tiposValorMinimo; track tipo.value) {
                      <vivest-radio
                        label-variant="multi-line"
                        name="tipo-valor-minimo"
                        [value]="tipo.value"
                        formControlName="tipo"
                        [attr.data-testid]="'opcoes-renda-tipo-' + tipo.value"
                      >
                        {{ tipo.label }}
                      </vivest-radio>
                    }
                  </div>
                </div>

                <div class="elegibilidade-campo">
                  @if (form.controls.valorMinimo.controls.tipo.value === 'valor') {
                    <label class="campanha-form-label" for="opcoes-renda-valor">
                      Valor mínimo inicial<span class="campanha-form-required" aria-hidden="true">*</span>
                    </label>
                    <div class="elegibilidade-moeda">
                      <span class="elegibilidade-moeda__prefixo" aria-hidden="true">R$</span>
                      <input
                        id="opcoes-renda-valor"
                        type="text"
                        inputmode="numeric"
                        appMascaraMoeda
                        placeholder="0,00"
                        class="form-control campanha-form-control elegibilidade-moeda__input"
                        formControlName="valor"
                        [class.is-invalid]="!!erroValorMinimo()"
                        [attr.aria-describedby]="erroValorMinimo() ? 'opcoes-renda-valor-erro' : null"
                        data-testid="opcoes-renda-valor"
                      />
                    </div>
                  } @else {
                    <label class="campanha-form-label" for="opcoes-renda-percentual">
                      Percentual sobre o saldo<span class="campanha-form-required" aria-hidden="true">*</span>
                    </label>
                    <div class="elegibilidade-moeda elegibilidade-moeda--percentual">
                      <input
                        id="opcoes-renda-percentual"
                        type="number"
                        inputmode="decimal"
                        min="0.01"
                        max="100"
                        step="0.01"
                        placeholder="0"
                        class="form-control campanha-form-control elegibilidade-moeda__input"
                        formControlName="percentual"
                        [class.is-invalid]="!!erroValorMinimo()"
                        [attr.aria-describedby]="erroValorMinimo() ? 'opcoes-renda-valor-erro' : null"
                        data-testid="opcoes-renda-percentual"
                      />
                      <span class="elegibilidade-moeda__sufixo" aria-hidden="true">%</span>
                    </div>
                  }
                  @if (erroValorMinimo(); as mensagem) {
                    <p id="opcoes-renda-valor-erro" class="elegibilidade__erro" role="alert">{{ mensagem }}</p>
                  }
                </div>
              }
            </div>
          </fieldset>
        </form>
      </section>

      <aside class="elegibilidade-resumo" aria-labelledby="opcoes-renda-resumo-titulo" data-testid="opcoes-renda-resumo">
        <h3 id="opcoes-renda-resumo-titulo" class="elegibilidade-resumo__titulo">Resumo{{ nomePlano() ? ' (' + nomePlano() + ')' : '' }}</h3>
        <ul class="elegibilidade-resumo__itens" data-testid="opcoes-renda-resumo-itens">
          @for (item of resumo(); track $index) {
            <li>{{ item }}</li>
          }
        </ul>
      </aside>
    </div>

    <footer class="elegibilidade__rodape">
      @if (temAlteracoes()) {
        <span class="elegibilidade__pendente" data-testid="opcoes-renda-alteracoes-pendentes">
          Há alterações não salvas
        </span>
      }
      <vivest-button variant="outline" size="md" [disabled]="!temAlteracoes()" data-testid="opcoes-renda-cancelar" (click)="descartar()">
        Cancelar
      </vivest-button>
      <vivest-button variant="primary" size="md" [disabled]="!temAlteracoes()" data-testid="opcoes-renda-salvar" (click)="salvar()">
        <vivest-icon slot="icon-left" name="save" source="feather"></vivest-icon>
        {{ salvando() ? 'Salvando…' : 'Salvar' }}
      </vivest-button>
    </footer>
  }
</section>

<vivest-modal
  heading="Salvar opções de renda"
  description="As opções passam a valer para todos os benefícios do plano nas próximas solicitações. Confirma?"
  [open]="confirmandoSalvar()"
  [hasIcon]="false"
  dismissible=""
  (vivest-close)="confirmandoSalvar.set(false)"
  data-testid="opcoes-renda-confirmar"
>
  <vivest-button slot="actions" variant="outline" size="md" data-testid="opcoes-renda-confirmar-voltar" (click)="confirmandoSalvar.set(false)">
    Voltar
  </vivest-button>
  <vivest-button slot="actions" variant="primary" size="md" data-testid="opcoes-renda-confirmar-salvar" (click)="confirmarSalvar()">
    Salvar
  </vivest-button>
</vivest-modal>
